import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function EventCollectionIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 40 40" fill="none" {...props}>
      <Box
        as="path"
        fill="currentColor"
        d="M5.3 11.305c-1.394-3.797 2.363-7.336 6.069-5.97l2.023.746a1.668 1.668 0 0 1-1.152 3.128l-2.025-.746c-1.155-.425-2.158.679-1.786 1.693l7.566 20.623c.433 1.182 2.156 1.184 2.592.004l2.847-7.72.14-.322a3.183 3.183 0 0 1 1.772-1.568l7.419-2.66a1.321 1.321 0 0 0-.044-2.517l-.544-.176a1.666 1.666 0 0 1 1.02-3.172l.544.174c4.263 1.371 4.368 7.315.149 8.828l-7.355 2.637-2.82 7.648c-1.508 4.09-7.348 4.086-8.85-.006L5.299 11.305Z"
      />
      <Box
        as="path"
        fill="currentColor"
        fillOpacity="0.6"
        d="M20.552 5.898c.258-1.198 1.97-1.197 2.228 0l.127.588a2.962 2.962 0 0 0 2.272 2.274l.588.125c1.2.258 1.2 1.97 0 2.228l-.588.127a2.962 2.962 0 0 0-2.272 2.272l-.127.588c-.258 1.2-1.97 1.2-2.228 0l-.125-.588a2.962 2.962 0 0 0-2.274-2.272l-.588-.127c-1.198-.258-1.198-1.97 0-2.228l.588-.125a2.962 2.962 0 0 0 2.274-2.274l.125-.588Z"
      />
    </Icon>
  );
}
